import React, { FC, useContext } from 'react'
import {  Switch, Grid } from '@mui/material';
import ImportantTextBox from '../common/ImportantTextBox'
import {FormStyles} from "../../config/Theme";
import {LanguageContext} from "../../config/ContextConfig";
import {VisibilityHandler} from "../common/VisibilityHandler";
import {makeStyles} from "@mui/styles";

interface BasicSwitchProps {
    label: string
    checked: boolean
    value?: string
    name?: string
    disabled?: boolean
    labelTrue?: string
    labelFalse?: string
    helperText?: string
    importantHelperText?: string
    className?: string
    onchange?: ( event: React.ChangeEvent<HTMLInputElement>, checked: boolean ) => void
    onChange?: ( event: React.ChangeEvent<HTMLInputElement>, checked: boolean ) => void
}

const useStyles = makeStyles( theme => ({
    ...FormStyles( theme ),
    standardWidth: {
        width: 99+'%'
    }
}) );

/**
 * BasicSwitch
 *
 * BasicSwitch provides a component to render a switch, which can be used for boolean values in forms
 *
 * @param props
 * @constructor
 */
function BasicSwitch( props: BasicSwitchProps ) {
    const language = useContext( LanguageContext );
    const classes = useStyles();


    return (
        <fieldset className={ "input-select-fieldset "+ (props.className || classes.standardWidth ) }>
            <legend>{props.label}</legend>
            <Grid component="label" container alignItems="center" className={ classes.switchGridRoot }>
                <Grid item>{( typeof props.labelFalse !== 'undefined' ) ? props.labelFalse : language.common.inputSwitch.labelFalse}</Grid>
                <Grid item>
                    <Switch
                        disabled={ props.disabled }
                        checked={ props.checked }
                        value={ props.value }
                        onChange={ props.onchange || props.onChange }
                        name={ props.name }
                        classes={ ( props.disabled && props.checked ) ? {
                            disabled: classes.activeDisabledSwitchKnob,
                            track: classes.activeDisabledSwitchTrack
                        } : {} }
                    />
                </Grid>
                <Grid item>{( typeof props.labelTrue !== 'undefined'  ) ? props.labelTrue : language.common.inputSwitch.labelTrue}</Grid>
            </Grid>
            <VisibilityHandler isVisible={ props.importantHelperText ? true : false }>
                <ImportantTextBox text={ props.importantHelperText || '' } />
            </VisibilityHandler>
        </fieldset>
    );
}

export default BasicSwitch;